import React from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';

import { AGENDADA } from '../../data/audienceStates';
import { ICON_EYE, ICON_FOLDER, ICON_PRIORITY } from '../extras/icons';
import priorities from '../../data/priorities';
import { PROFILE_OGA, PROFILE_SISTEMAS } from '../../data/profiles';


const WorkRow = props => {
    
    // Tomo los props
    const { audience, authUser } = props    

    // Traducciones
    const priorityMap = {
        low: 'Baja',
        medium: 'Media',
        high: 'Alta',
    };
    const statusMap = {
        REQUESTED: 'Solicitud',
        APPROVED: 'Aprobada',
    };
    
    // Renderizo
    return (
        <tr>
            {   authUser.perfil.id === PROFILE_OGA || authUser.perfil.id === PROFILE_SISTEMAS ? (
                    <td className="align-middle text-center">
                        {   (audience.prioridad || audience.priority) ? (
                                <ICON_PRIORITY
                                className={`text-${
                                    priorities.find(
                                    p =>
                                        p.id === audience.prioridad?.id ||
                                        p.descripcion === priorityMap[audience.priority]
                                    )?.css
                                }`}
                                />
                            ) : null
                        }
                    </td>
                ) : null
            }
            <td className="align-middle text-center">
                <small>
                <strong>{ audience.id }</strong>
                </small>
            </td>
            {   authUser.perfil.id === PROFILE_OGA || authUser.perfil.id === PROFILE_SISTEMAS ? (
                    <React.Fragment>
                        <td className="align-middle text-center">
                            <small>
                            { audience.fechaSolicitud ? moment(audience.fechaSolicitud).format('DD/MM/YYYY HH:mm') : '' }
                            { audience.created_at ? moment(audience.created_at).format('DD/MM/YYYY HH:mm') : '' }
                            </small>
                        </td>
                        <td className="align-middle">
                            <small>
                            { audience.solicitante?.descripcion ?? audience.requesting_office ?? 'N/D' }
                            </small>
                        </td>  
                        <td className="align-middle">
                            <small>
                            { audience.estado?.descripcion ?? statusMap[audience.status] ?? 'N/D' }
                            </small>
                        </td>   
                    </React.Fragment>                    
                ) : (
                    <td className="align-middle text-center">
                        <small>
                        { audience.inicio ? moment(audience.inicio).format('DD/MM/YYYY HH:mm') : '' }
                        {   audience.sala ? (
                                <React.Fragment>
                                    <br/>
                                    <strong>{ audience.sala.descripcion }</strong>
                                </React.Fragment>
                            ) : null
                        }
                        </small>
                    </td>
                )
            }
            <td className="align-middle">
                <small>
                <strong>
                    { audience.expediente?.numero || audience.file_number }
                </strong>
                <br/>
                { audience.expediente?.caratula || audience.case_title }
                </small>
            </td>

            <td className="align-middle text-center">
                {   audience.audienciaTipoList ? (
                        audience.audienciaTipoList.map((type, index) => (
                            <small key={`wrat${type.id}`}>
                                {`${index > 0 ? '|' : ''}${type.descripcion}`}
                            </small>
                        ))
                    ) : null
                }
                {   audience.audience_types?.map((type, index) => (
                        <small key={`wrat${type}`}>
                            {`${index > 0 ? '|' : ''}${type}`}
                        </small>
                    ))
                }
            </td>

            
            
            <td className="align-middle text-center">
                {   audience.estado?.id <= AGENDADA && authUser.perfil.id === PROFILE_OGA ? (
                        <Link className="btn btn-primary btn-circle btn-sm ml-2" to={`/audiencias/${audience.id}/formulario-trabajo/informacion`}>
                            <ICON_FOLDER />
                        </Link>
                    ) : (
                        <Link className="btn btn-info btn-circle btn-sm ml-2" to={`/audiencias/${audience.id}/ver`} target="_blank">
                            <ICON_EYE />
                        </Link>
                    )
                }
            </td>
        </tr>
    );
};

export default WorkRow;